import { render, staticRenderFns } from "./RuleRotation.vue?vue&type=template&id=d2e54230"
import script from "./RuleRotation.vue?vue&type=script&lang=js"
export * from "./RuleRotation.vue?vue&type=script&lang=js"
import style0 from "./RuleRotation.vue?vue&type=style&index=0&id=d2e54230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports